(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["game-over-catalogue"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('game-over-carousel')) {
  class GameOverCarousel extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.grid = this.querySelector('.go-products');
      this.controls = this.querySelector('.go-controls');
      this.status = this.querySelector('[data-status]');
      this.toggle = this.querySelector('[data-toggle]');
      this.cards = [...this.querySelectorAll('[data-product-id]')];
      this.ids = new Set();
      this.cards = this.cards.filter(card => {
        if (this.ids.has(card.dataset.productId)) {card.remove(); return false;}
        this.ids.add(card.dataset.productId); return true;
      });
      this.page = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.focused = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('[data-prev]').addEventListener('click', () => {this.page--; this.render(); this.schedule();}, options);
      this.querySelector('[data-next-button]').addEventListener('click', () => this.advance(), options);
      this.toggle.addEventListener('click', () => {this.paused = !this.paused; this.render(); this.schedule();}, options);
      this.grid.addEventListener('mouseenter', () => {this.hovered = true; this.schedule();}, options);
      this.grid.addEventListener('mouseleave', () => {this.hovered = false; this.schedule();}, options);
      this.grid.addEventListener('focusin', () => {this.focused = true; this.schedule();}, options);
      this.grid.addEventListener('focusout', event => {this.focused = this.grid.contains(event.relatedTarget); this.schedule();}, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.render();
      this.schedule();
      this.loadMore();
    }
    disconnectedCallback() {clearTimeout(this.timer); this.abort?.abort(); this.ready = false;}
    render() {
      const groups = Math.ceil(this.cards.length / 4);
      this.controls.hidden = groups <= 1;
      if (!groups) return;
      this.page = (this.page + groups) % groups;
      const visible = new Set();
      for (let i = 0; i < Math.min(4, this.cards.length); i++) visible.add((this.page * 4 + i) % this.cards.length);
      this.cards.forEach((card, i) => {
        const show = visible.has(i);
        card.hidden = !show;
        card.classList.toggle('go-enter', show);
      });
      this.status.textContent = `${this.dataset.group} ${this.page + 1} / ${groups}`;
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.toggle.setAttribute('aria-pressed', String(this.paused));
    }
    advance() {this.page++; this.render(); this.schedule(); this.loadMore();}
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.paused || this.hovered || this.focused || document.hidden || this.cards.length <= 4) return;
      this.timer = setTimeout(() => this.advance(), Number(this.dataset.interval) || 6000);
    }
    async loadMore() {
      if (!this.dataset.next || this.loading) return;
      this.loading = true;
      try {
        const url = new URL(this.dataset.next, window.location.href);
        url.searchParams.set('section_id', this.dataset.section);
        const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, {signal: this.abort.signal});
        if (!response.ok) throw new Error('Catalogue unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('game-over-carousel');
        if (!next) throw new Error('Catalogue unavailable');
        next.querySelectorAll('[data-product-id]').forEach(card => {
          if (this.ids.has(card.dataset.productId)) return;
          this.ids.add(card.dataset.productId); card.hidden = true;
          this.grid.append(card); this.cards.push(card);
        });
        this.dataset.next = next.dataset.next || '';
        this.render();
      } catch (error) {
        if (error.name !== 'AbortError') this.dataset.next = '';
      } finally {this.loading = false;}
    }
  }
  customElements.define('game-over-carousel', GameOverCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
